export const numberFormatter = (number: number, options: any): string =>
  Intl.NumberFormat('it-IT', options).format(number)
